export const processData = (response, storedData) => {
  (response || []).map(responsible => {
    responsible['students'].map(student => {
      student.temporary = false
    })

    responsible['temporary_students'].map(student => {
      student.temporary = true
    })

    responsible.studentsCollection = responsible.students.concat(responsible['temporary_students'])
  })

  processStudentsSelection(response, extractStudents(storedData))

  return response
}

export const processButtonState = responsibles => {
  let count = 0

  responsibles.map(responsible => {
    responsible.studentsCollection.map(student => {
      if (student.checked && !student.absent) {
        count += 1
      }
    })
  })

  return count === 0
}

const extractStudents = (responsibles) => {
  const allStudents = []

  responsibles.map(responsible => {
    responsible.studentsCollection.map(student => {
      allStudents.push(student)
    })
  })

  return allStudents
}

const processStudentsSelection = (response, originalStudents) => {
  response.map(responsible => {
    responsible.studentsCollection.map(student => {
      const originalStudent = originalStudents
        .find(originalStudent => originalStudent.id === student.id)

      if (originalStudent && !student.absent) {
        student.checked = originalStudent.checked
      } else {
        student.checked = false
      }
    })
  })
}
